export default [
  {
    label: '日時',
    key: 'created_at',
    _style: 'min-width:160px',
    sorter: false,
  },
  {
    label: 'アライアンス名',
    key: 'company',
    _style: 'min-width:180px',
    sorter: false,
  },
  {
    label: 'マネージャID/マネージャ名',
    key: 'admin_name',
    _style: 'min-width:200px',
    sorter: false,
  },
  {
    label: '操作',
    key: 'operation',
    _style: 'min-width:200px',
    sorter: false,
  },
]
